<template>
  <div class="content d-flex justify-content-between my-5">
    <div class="d-flex flex-row-reverse-perso gap-3 item">
      <div class="user-avatar d-md-block">
        <img loading="lazy" :src="getOrgaPicture" alt="" width="80" height="80"
          class="rounded-circle img-fluid shadow-sm">
      </div>

      <div class="left-content d-flex flex-column text-section">

        <div>
          <h2 :class="{ 'text-danger': hasOrgaName === null }" class="mb-0 h4 text-break">
            {{ getOrgaName }}
          </h2>

          <p class="mb-0 ">
            <a target="_blank" v-if="this.item.partner_group.orga_twitter" :href="this.item.partner_group.orga_twitter"
              class="btn btn-link p-0">
              <i class="fab fa-twitter"></i> {{ getTwitterTag }}
            </a>
          </p>

          <p v-if="this.item.partner_group.orga_name_full" class="medias my-0 text-break">
            {{ this.item.partner_group.orga_name_full }}
          </p>

          <p v-if="!this.item.partner_group.show_orga_address" class="mb-0 ">
            <i class="fas fa-map-marker-alt"></i> {{ getOrgaAddress }}
          </p>
        </div>

        <div class="hidden-small">
          <p v-if="hasManyManagers || hasManyContacts" class="d-flex flex-column gap-2">
          <div v-if="hasManyManagers">
            <PartnerContactsModal :contacts="this.item.partner_group.orga_managers"
              :id="'managers_' + this.item.id.toString()" button-text="Afficher tous les responsables" class="btn-auto" />
          </div>

          <div v-if="hasManyContacts">
            <PartnerContactsModal :contacts="this.item.partner_group.contacts" :id="'contacts_' + this.item.id.toString()"
              button-text="Afficher tous les contacts" class="btn-auto" />
          </div>
          </p>
        </div>

      </div>
    </div>

    <div class="right-sidebar">
      <PartnerContacts
        :contacts="{ managers: this.item.partner_group.orga_managers, contacts: this.item.partner_group.contacts }" />

      <div class="hidden-large">
        <p v-if="hasManyManagers || hasManyContacts" class="d-flex flex-column gap-2">
        <div v-if="hasManyManagers">
          <PartnerContactsModal :contacts="this.item.partner_group.orga_managers"
            :id="'managers_' + this.item.id.toString()" button-text="Afficher tous les responsables" class="btn-auto" />
        </div>

        <div v-if="hasManyContacts">
          <PartnerContactsModal :contacts="this.item.partner_group.contacts" :id="'contacts_' + this.item.id.toString()"
            button-text="Afficher tous les contacts" class="btn-auto" />
        </div>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import PartnerContacts from '@/components/partner/PartnerContacts'
import PartnerContactsModal from '@/components/partner/PartnerContactsModal'

export default {
  name: 'DirectorySinglePartner',
  components: {
    PartnerContacts,
    PartnerContactsModal
  },

  props: {
    item: Object
  },

  computed: {
    hasManyManagers() {
      return this.item.partner_group.orga_managers.length > 1;
    },

    hasManyContacts() {
      return this.item.partner_group.contacts.length > 1;
    },

    showEmail() {
      return !this.item.partner_group.show_orga_address;
    },

    hasOrgaName() {
      return !!(this.item.partner_group.orga_name);
    },

    getOrgaName() {
      if (this.hasOrgaName === true) {
        return this.item.partner_group.orga_name.trim();
      }

      return "Non spécifié";
    },

    getOrgaPicture() {
      return this.item.partner_group.logo.url ?? this.item.avatar_url;
    },

    getOrgaAddress() {
      const address = this.item.partner_group.orga_address;
      const city = this.item.partner_group.orga_city;
      const postal_code = this.item.partner_group.orga_postal_code;

      return [address, city, postal_code].join(' - ');
    },

    getSubjects() {
      return this.item.journalist_group.subjects.join(' - ')
    },

    getMedias() {
      if (Array.isArray(this.item.journalist_group.medias)) {
        return this.item.journalist_group.medias.map((media) => media.post_title).join(', ').trim().char(0).ucFirst();
      }

      return 'Non spécifié';
    },

    getTwitterTag() {
      return '@' + this.item.partner_group.orga_twitter.match(/\/([^\/]+)$/)[1];
    }
  }
}
</script>

<style scoped>
.medias {
  text-transform: uppercase;
  color: #F05A28;
}

.user-avatar img {
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  object-fit: scale-down;
}

.right-sidebar {
  flex-basis: 30%;
}

.left-content {
  flex-basis: 70%;
}

.item {
  width: 80%;
}

.btn-auto {
  width: fit-content;
}

.btn-link {
  color: #00b0b0 !important;
}

.btn-link:hover {
  color: #F05A28 !important;
}

@media (min-width: 768px) {
  .hidden-large {
    display: none;
  }
}

@media (max-width: 767px) {
  .item {
    width: 100%;
  }

  .hidden-small {
    display: none;
  }

  .content {
    flex-direction: column;
  }

  .left-content {
    flex-basis: 100%;
  }

  .flex-row-reverse-perso {
    flex-direction: row-reverse;
  }
}

@media (max-width: 375px) {
  .user-avatar img {
    width: 65px;
    height: 65px;
    min-width: 65px;
    min-height: 65px;
  }
}

@media (max-width: 320px) {
  .flex-row-reverse-perso {
    flex-direction: column;
  }

  .user-avatar img {
    width: 55px;
    height: 55px;
    min-width: 55px;
    min-height: 55px;
  }
}
</style>
